import BaseApi from "./BaseApi";
import qs from "qs";

export const getPlaceHoldersApi = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  return await BaseApi.get(`/placeholders/GetPlaceHolders?${reqStr}`);
};

export const getAnalyticsPlaceHoldersApi = async reqObj => {
  return await BaseApi.post(`/placeholders/GetAnalyticsMarkup`, reqObj);
};



// WEBPACK FOOTER //
// ./src/api/placeHolders.js